module.exports = __webpack_public_path__ + "static/img/2.996526d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/2.jpg
// module id = kksO
// module chunks = 1